import { Skeleton, Stack } from "@mui/material";

const AVATAR_SIZE = 40;

/**
 * Renders a skeleton/loading placeholder for a member list item card.
 * Displays animated skeleton elements in the same layout as ListItemCardMobile.
 *
 * @returns Skeleton placeholder with circular avatar and text lines
 */
export function SkeletonMemberListItemCard(): JSX.Element {
  return (
    <Stack
      flexDirection="row"
      gap={1}
      p={1}
      alignItems="center"
    >
      <Skeleton
        variant="circular"
        width={AVATAR_SIZE}
        height={AVATAR_SIZE}
      />

      <Stack flex={1} minWidth={0} gap={0.5}>
        <Skeleton width="60%" height={16} />
        <Skeleton width="40%" height={14} />
        <Skeleton width="50%" height={14} />
      </Stack>
    </Stack>
  );
}